


































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../shared/services/mixin";
import {Component, Watch} from "vue-property-decorator";
import {ReceiptPartnerParams} from "@/modules/receiptsexpenses/receiptpartner/params";
import {ReceiptPartnerStore} from "@/modules/receiptsexpenses/receiptpartner/store";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import {LadingPaymentType, PartnerType} from "@/enums/type";
import LadingPaymentTypeLabel from "@/modules/ladings/List/components/PaymentTypeLabel.vue";
import PartnerSelector from "@/shared/components/PartnerSelector/index.vue";
import ReceiptPartnerTable from "@/modules/receiptsexpenses/receiptpartner/List/ReceiptPartnerTable/index.vue";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import {allDebtPartner} from "@/modules/receiptsexpenses/receiptpartner/services";
import ReceiptPartnerExcel from "@/modules/receiptsexpenses/receiptpartner/List/ReceiptPartnerExcel/index.vue";
import TableToExcel from "@linways/table-to-excel";

@Component({
    name: "DebtPartner",
    components: {ReceiptPartnerExcel, ReceiptPartnerTable, PartnerSelector, LadingPaymentTypeLabel, LadingStatusLabel}
})
export default class extends mixins(CommonMixin) {
    params: ReceiptPartnerParams = new ReceiptPartnerParams();
    LadingPaymentType = LadingPaymentType;
    PartnerType = PartnerType;
    debtsReceiptPartnerExcel = [] as any;
    isExporting = false;

    created() {
        ReceiptPartnerStore.updateParamsDebtPartner(this.params);
        ReceiptPartnerStore.listDebtPartner(ReceiptPartnerStore.params);
    }

    @Watch("params", {deep: true})
    onChangeParams(val: any) {
        ReceiptPartnerStore.updateParamsDebtPartner({...val, page: 1});
        ReceiptPartnerStore.listDebtPartner(ReceiptPartnerStore.params);
    }

    get debtPartners() {
        return ReceiptPartnerStore.ids.map((id: number) => ReceiptPartnerStore.data[id]);
    }

    get pagination() {
        return {
            current: ReceiptPartnerStore.meta.page,
            pageSize: ReceiptPartnerStore.meta.limit,
            total: ReceiptPartnerStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} bản ghi`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        ReceiptPartnerStore.updateParamsDebtPartner({
            ...ReceiptPartnerStore.params,
            page: pagination.current,
            limit: pagination.pageSize
        })
        ReceiptPartnerStore.listDebtPartner(ReceiptPartnerStore.params);
    }

    async exportExcel() {
        try {
            await this.getDataExport();
            setTimeout(() => {
                TableToExcel.convert(document.getElementById("table-excel-receipt-partner"), {
                    name: `Danh sách thu đối tác.xlsx`,
                    sheet: {
                        name: "Sheet 1"
                    }
                });
            }, 200)
        } catch (e) {
        }
    }

    async getDataExport() {
        try {
            this.isExporting = true;
            const { data } = await allDebtPartner(ReceiptPartnerStore.params);
            this.debtsReceiptPartnerExcel = data.datas;
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Xuất excel lỗi");
        } finally {
            this.isExporting = false;
        }
    }
}
